import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import { superstyled } from '@zenbusiness/zui/styles';

export const StyledArrowCircleUpIcon = superstyled({
  tag: ArrowCircleUpIcon,
  name: 'AssistantInput',
  slot: 'StyledArrowCircleUpIcon',
  styles: {
    width: '1.5rem',
    height: '1.5rem',
  },
});

// Preserve the original icon's displayName so IconButton's clickstream elementAsset
// auto-detection (which reads the icon's displayName) is unaffected by this wrapper.
StyledArrowCircleUpIcon.displayName = 'ArrowCircleUpIcon';
